/**
 * Settings module translations - Buttons section
 */

const buttons = {
  addPeppolNumber: "Agregar número Peppol",
  applyForPeppolNumber: "Solicitar número Peppol",
  addTaxId: "Agregar ID fiscal",
  addBankAccount: "Agregar cuenta bancaria",
  addCountry: "Agregar país",
  edit: "Editar",
  delete: "Eliminar",
  cancel: "Cancelar",
  save: "Guardar",
  submit: "Enviar",
  manageProducts: "Gestionar productos",
  addKsefToken: "Añadir token KSeF",
  manageKsefToken: "Gestionar token KSeF",
  replaceKsefToken: "Reemplazar token",
  removeKsefToken: "Eliminar token",
  editLanguage: "Editar idioma",
  setLanguage: "Establecer idioma",
  changeStatus: "Cambiar estado",
  uploadFiles: "Subir archivos",
  addRegistrationInfo: "Añadir información de registro",
  addProductLine: "Agregar línea de producto"
};

export default buttons;
